import type { NavView } from "./navigationTypes";

export const routeAuthRequirements = {
  "/": false,
  "/solver": true,
  "/results": true,
  "/results/c/:configHash": true,
  "/history": true,
  "/preflop-solutions": true,
  "/easy-preflop-solutions": true,
  "/preflop-trace": true,
  "/preflop-trace-2": true,
  "/ai-setup": false,
  "/auth/error": false,
  "/image-relay/connect": false,
  "/settings": false,
  "/solve/:token": false,
  "/card-mnemonic": false,
  "/game": false,
  "/play": false,
  "/documents": false,
  "/documents/preflop-walkthrough": false,
  "/documents/postflop-code-flow": false,
  "/documents/regret-sync-strategies": false,
} as const;

export type AuthRoutePath = keyof typeof routeAuthRequirements;

export const navViewRoutePath: Record<NavView, AuthRoutePath> = {
  home: "/",
  solver: "/solver",
  "ai-setup": "/ai-setup",
  results: "/results",
  "solve-history": "/history",
  settings: "/settings",
  "preflop-solutions": "/preflop-solutions",
  "easy-preflop-solutions": "/easy-preflop-solutions",
  "preflop-trace": "/preflop-trace",
};

export function requiresAuthForRoutePath(path: AuthRoutePath): boolean {
  return routeAuthRequirements[path];
}

export function requiresAuthForNavView(navView: NavView): boolean {
  return requiresAuthForRoutePath(navViewRoutePath[navView]);
}
